import { useTranslation } from 'react-i18next';
import { useMeQuery, useMembersQuery } from '@platform/state/api';
import { useLabel } from '@platform/hooks/useLabel';
import { workspaceType } from '@platform/navigation';
import type { IWorkspace } from '@platform/core/types';

/**
 * Поточний робочий простір і його підпис «тип · N учасників» (перемикач просторів, заголовок лівого меню Головної): тип — з моделі
 * навігації (Комітет, Парламент…), кількість учасників — GET /workspaces/{id}/members; доки вона вантажиться — лише тип.
 */
export function useWorkspaceMeta(ws: string): { workspace: IWorkspace | undefined; meta: string } {
  const { t } = useTranslation();
  const label = useLabel();
  const { data: me } = useMeQuery();
  const { data: members } = useMembersQuery(ws, { skip: !ws });
  const workspace = me?.workspaces.find((w) => w.id === ws);
  const type = label(workspaceType(workspace?.type ?? 'mp').label);
  return { workspace, meta: members ? t('shell.wsMeta', { type, members: t('shell.members', { count: members.length }) }) : type };
}
